import axios, { AxiosResponse } from "axios";
import { ApiError } from "../ApiError";
import apis from "../apis";

export class DeleteSpaceEndpoint implements IDeleteSpaceEndpoint
{
    public async execute(nodeId: number, spaceId: string): Promise<void>
    {
        try
        {
            const response = await axios.delete(`${apis.dataEntryApiV2}${nodeId}/Spaces/${spaceId}`);
            throw response;
        }
        catch (response)
        {
            throw ApiError.fromAxiosResponse(response as AxiosResponse);
        }
    }
}

export interface IDeleteSpaceEndpoint
{
    execute(nodeId: number, spaceId: string): Promise<void>;
}
